import TagTable from "./tagTable.container";

export default TagTable;
